// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4366":"9b524a2e","6636":"c1349867"}[chunkId] + ".chunk.css";
};